/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay
     */
    AppId: number;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    if (json == null) {
        return json;
    }
    return {
        
        'AppId': json['AppId'],
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppId': value['AppId'],
    };
}

